import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TixxSelectService } from '~core/services';
import { TooltipTranslationService } from '~shared/translations';
import { ExecutionIteration, Lottery } from '~core/models';
import { TablesTranslations } from '~shared/components/tables/tables-translations.service';

/**
 * Handles execution iteration list.
 */
@UntilDestroy()
@Component({
  selector: 'app-execution-iteration-list',
  templateUrl: './execution-iteration-list.component.html',
})
export class ExecutionIterationListComponent implements OnInit, OnDestroy {
  public columns: Array<string> = [];
  public keys: Array<Array<string>> = [];
  public spinnerName = 'eventDashboardRefresh';

  public completedExecutionIterations: Array<ExecutionIteration>;
  public baseApi: string;
  public customQueries: Array<any> = [];

  @Input() public selectedLottery: Lottery;
  @Input() public executionIterations: Array<ExecutionIteration>;

  @Input() public isActivePanelOpened: boolean = true;
  @Input() public isCompletedPanelOpened: boolean = true;

  constructor(
    public tablesTranslations: TablesTranslations,
    public tooltipTranslations: TooltipTranslationService,
    public tixxSelectService: TixxSelectService
  ) {
    this.columns.push(
      this.tablesTranslations.i18nDate,
      this.tablesTranslations.i18nType,
      this.tablesTranslations.i18nPriceCategory,
      this.tablesTranslations.i18ntoBeSeatedTicketCount,
      this.tablesTranslations.i18nSuccessfullySeatedTicketCount,
      this.tablesTranslations.i18nStatus,
    );
    this.keys.push(['createdAt', 'translatedType', 'priceCategory.name', 'capacity',
      'reservationSummary.numberOfSuccessfullySeatedTickets', 'displayStatus']);
  }

  public ngOnInit(): void {
    this.getExecutionSubmissions(this.selectedLottery.executionId);
  }

  public ngOnDestroy(): void { }

  /**
   * Get the execution iterations results table.
   */
  public getExecutionSubmissions(id: number): any {
    const endpoint = this.tixxSelectService.getExecutionIterationEndpoint(id);
    this.baseApi = endpoint[0];
    this.customQueries = endpoint[1];
  }

  /**
   * Sets the new execution iteration list
   */
  public createSubmissionObject(iterations: Array<ExecutionIteration>): void {
    const data = this.tixxSelectService.createExecutionIterationObject(iterations);
    this.completedExecutionIterations = data;
  }
}
